import React, { Component } from 'react';
// import { Parallax } from 'react-skrollr'

import styles from  './styles.js';

class Workshop extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
		});

		let styleLeft = Object.assign({},styles.workshopItem, {
			backgroundImage: ` url('images/byg-1-comp.jpg') `,
		})

		let styleCenter = Object.assign({},styles.workshopItem, {
			backgroundImage: ` url('images/byg-2-comp.jpg') `,
		})

		let styleRight = Object.assign({},styles.workshopItem, {
			backgroundImage: ` url('images/byg-3-comp.jpg') `,
		})

		return (
			<div style={elmStyl} className='kulturEvent'>
				<div style={styles.flex}>
					<div style={styleCenter}
						data-0-start="background-position-x: -300px"
						data-end="background-position-x: -300px">
					</div>
					<div style={styleLeft}
						data-0-start="background-position-y: -300px"
						data-end="background-position-y: 500px">
					</div>

					<div style={styleRight}
						data-0-start="background-position-x: -300px"
						data-end="background-position-x: -300px">
					</div>
				</div>
			</div>

		)
	}
}

export default Workshop;





// WEBPACK FOOTER //
// ./src/components/Workshop.js